export * from './src/bookings-v1-category-categories.meta.js';
